<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getTimeTableColumn } from '@/utils/common/tableColumn'
import {
  generateHeader,
  generateStyles,
  getSummaryData,
  getSummary,
  getSubTitle,
  getServerHealthStatusData,
  getServerHealthStatus,
  getMysqlHealthStatusData,
  getK8sHealthStatusData,
  getHealthStatus,
} from '../utils/report'
import { getStatusTableColumn } from '../utils/columns'
import singleActionsMixin from '../mixins/singleActions'
import groupActionsMixin from '../mixins/groupActions'

export default {
  name: 'InspectionList',
  mixins: [WindowsMixin, ListMixin, singleActionsMixin, groupActionsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'checks',
        apiVersion: 'v1',
        fetchDataCb: this.fetchDataCb,
        getParams: this.getParam,
        filterOptions: {},
        noPreLoad: true,
      }),
      columns: [
        getTimeTableColumn({ title: this.$t('inspection.columns.time') }),
        getStatusTableColumn(),
      ],
      listRefreshTimer: null,
    }
  },
  created () {
    this.checkManager = new this.$Manager('checks', 'v1')
    this.list.fetchData()
  },
  beforeDestroy () {
    this.checkManager = null
    clearTimeout(this.listRefreshTimer)
  },
  methods: {
    async fetchDataCb (response) {
      const data = response.data.data
      data.forEach(item => {
        try {
          const results = JSON.parse(item.results || '{}')
          if (R.isEmpty(results)) {
            item.status = 'pending'
          } else if (results.Status === 'ERROR') {
            item.status = 'error'
          } else {
            item.status = 'success'
          }
        } catch (error) {
          console.log('parse results error', error)
          item.status = 'error'
        }
      })

      clearTimeout(this.listRefreshTimer)
      this.listRefreshTimer = setTimeout(() => {
        const isNeedRefresh = data[0].results === '{}'

        if (isNeedRefresh) {
          this.list.fetchData()
        } else {
          clearTimeout(this.listRefreshTimer)
        }
      }, 10 * 1000)
    },
    getParam () {
      const ret = {
        ...this.getParams,
        record_type: 'routine_check',
      }
      return ret
    },
    generateDocDefinition (results, obj) {
      const docDefinition = {
        info: {
          title: `${this.$moment(obj.created_at).format()}-${this.$t('inspection.report')}`,
        },
        pageOrientation: 'landscape',
        pageSize: {
          width: 595.28 * 1.45,
          height: 841.89 * 1.45,
        },
      }
      docDefinition.styles = generateStyles()
      docDefinition.content = this.generateContent(results, obj)
      return docDefinition
    },
    generateContent (results, obj) {
      const sumaryData = getSummaryData(results, obj)
      const serverHealthStatusData = getServerHealthStatusData(results)
      const mysqlHealthStatusData = getMysqlHealthStatusData(results)
      const k8sHealthStatusData = getK8sHealthStatusData(results.K8s?.[0])

      return [
        ...generateHeader(),
        ...getSummary({ data: sumaryData }),
        ...getSubTitle({ title: `${this.$t('inspection.report.detailed_list')}` }),
        ...getServerHealthStatus({
          title: this.$t('inspection.report.columns.health_status.server'),
          data: serverHealthStatusData,
        }),
        ...getHealthStatus({
          title: this.$t('inspection.report.columns.health_status.mysql'),
          data: mysqlHealthStatusData,
        }),
        ...getHealthStatus({
          title: this.$t('inspection.report.columns.health_status.k8s'),
          data: k8sHealthStatusData,
        }),
      ]
    },
  },
}
</script>

<style>

</style>
